// Les 7 langues du site — exactement celles promises au dos de la boîte
// (FR EN NL DE LU ES PT). L'ordre est celui du sélecteur.
export const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'lb', label: 'Lëtzebuergesch', flag: '🇱🇺' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
];

export const DEFAULT_LANG = 'fr';

/**
 * Une langue n'est « disponible » que si son dictionnaire est réellement
 * rempli. Le seuil est volontairement bas mais non nul : un fichier vide ou
 * à peine ébauché ne doit pas apparaître dans le sélecteur, sinon le visiteur
 * choisit « Deutsch » et reçoit du français.
 *
 * Effet voulu : au fur et à mesure que les traductions arrivent, les langues
 * s'ajoutent d'elles-mêmes, sans qu'on ait à penser à modifier une liste.
 */
const SEUIL_TRADUCTION = 40;

export function languesDisponibles(dictionnaires) {
  return LANGUAGES.filter((l) => {
    if (l.code === DEFAULT_LANG) return true;
    return Object.keys(dictionnaires[l.code] || {}).length >= SEUIL_TRADUCTION;
  });
}
